
import React from "react"
import "../comp_styles/footer.css"


export default function Footer() {
    return (
        <div className="footerContain">
            <div className="creditText">Icons made by <a href="http://creativecommons.org/licenses/by/3.0/" rel="noopener noreferrer" title="Creative Commons BY 3.0" target="_blank">CC 3.0 BY</a>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/footer.js